import React, { useEffect, useRef, useState } from "react";
import { Button, Layout, Space, Table, Tag, Typography, Alert, Row, Input, Col, Divider, Select, Checkbox, Collapse, notification, Skeleton, Card } from 'antd';
import { EyeOutlined, PrinterOutlined, FilterOutlined, CaretLeftOutlined, CaretRightOutlined, StopOutlined } from '@ant-design/icons';
import { Link, useNavigate } from "react-router-dom";
import { inject, observer } from 'mobx-react'
import { cloneDeep } from "lodash";
import moment from "moment-timezone";
import "./style.scss";
import Swal from "sweetalert2";
import html2canvas from "html2canvas";

const { Content } = Layout;
const { Title, Text } = Typography;
const { Search } = Input;
const { Panel } = Collapse;

const Voters = ({ userStore, voterStore }) => {

  const [searchName, setSearchName] = useState();
  const [searchStreet, setSearchStreet] = useState();
  const [searchAddress, setSearchAddress] = useState();
  const [searchGender, setSearchGender] = useState();
  const [searchPWD, setSearchPWD] = useState(false);

  const [hasGender, setHasGender] = useState(false);
  const [hasStreet, setHasStreet] = useState(false);
  const [hasAddress, setHasAddress] = useState(false);
  const [hasPWD, setHasPWD] = useState(false);

  const [showData, setShowData] = useState(false);

  const [voterData, setVoterData] = useState(null);

  useEffect(() => {
    voterStore.page = 1;
    voterStore.hasMore = false;
    voterStore.perPage = 20;
    voterStore.fetchVoters();
  }, [])

  useEffect(() => {
    if(voterData != null) {
      handlePrint()
    }
  }, [voterData])

  useEffect(() => {
      const timeout = setTimeout(() => {
        setShowData(true);
      }, 500);
  
      return () => clearTimeout(timeout); // Clear the timeout if the component is unmounted
  
    }, []);

  const handlePrevPage = () => {
      voterStore.page = voterStore.page - 1;
      voterStore.fetchVoters();
  };

  const handleNextPage = () => {
      voterStore.page = voterStore.page + 1;
      voterStore.fetchVoters();
  };

  const handleSearchVoter = () => {
    if (!searchName && !searchStreet && !searchAddress && !searchGender && !searchPWD) {
      notification.error({
        top: 120,
        message: 'Error!',
        description: 'Please provide proper data for accurate results.'
      });
      return;
    } else if(searchName == ""){
        notification.error({
          top: 120,
          message: 'Error!',
          description: 'Please provide a Voter Name'
        });
        return;
    } else{

      const searchParams = {};
      if (searchName) searchParams.name = searchName;
      if (searchStreet) searchParams.street = searchStreet;
      if (searchAddress) searchParams.address = searchAddress;
      if (searchGender) searchParams.gender = searchGender;
      if (searchPWD) searchParams.pwd = searchPWD;

      voterStore.searchVotersMultipleData(searchParams);
    }
  };

  const onConfirmOpposition = (record) => {
    Swal.fire({
      title: "Mark as Opposition",
      icon: "question",
      text: "Are you sure do you want to mark this voter as Opposition?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: `Cancel`,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        userStore.markAsOpposition(record)
      } 
    })
  };

  const onConfirmUndecided = (record) => {
    Swal.fire({
      title: "Mark as Undecided",
      icon: "question",
      text: "Are you sure do you want to mark this voter as Undecided?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: `Cancel`,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        userStore.markAsUndecided(record)
      } 
    })
  };

  const columns = [
    {
      title: 'Name',
      key: 'FullName+VIN',
      dataIndex: 'FullName',
      render: (FullName) => (
        <Text default>{FullName}</Text>
      )
    },
    {
      title: 'Precinct',
      key: 'Precint+VIN',
      dataIndex: 'Precint',
      render: (Precint) => (
        <Text default>{Precint}</Text>
      )
    },
    {
      title: 'Street',
      key: 'Street+VIN',
      dataIndex: 'Street',
      render: (Street) => (
        <Text default>{Street}</Text>
      )
    },
    {
      title: 'Address',
      key: 'Address+VIN',
      dataIndex: 'Address',
      render: (Address) => (
        <Text default>{Address}</Text>
      )
    },
    {
      title: 'Gender',
      key: 'Sex+VIN',
      dataIndex: 'Sex',
      render: (Sex) => (
        <Text default>{Sex}</Text>
      )
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      fixed: "right",
      render: (text, record) => (
        <Space size={'small'} direction="vertical">
          <Link to={'/voters/'+record.VIN}><Button block icon={<EyeOutlined/>} type="primary" ghost>View</Button></Link>
          <Button block type="primary" ghost onClick={() => setVoterData(record)} icon={<PrinterOutlined/>}>Print Precinct</Button>
          <Button 
            block
            onClick={() => onConfirmOpposition(record)}
            loading={voterStore.loading}
            danger
            icon={<StopOutlined />}
            disabled={record.RemarksA === "OPPOSITION"}
          >Mark as Opposition</Button>
          <Button 
            block
            onClick={() => onConfirmUndecided(record)}
            loading={voterStore.loading}
            danger
            icon={<StopOutlined />}
            disabled={record.RemarksA === "UNDECIDED"}
          >Mark as Undecided</Button>
        </Space>
      )
    },
  ];

  const printRef = useRef();

  const handlePrint = async () => {
    const element = printRef.current;

    element.style.display = "block";

    const canvas = await html2canvas(element);
    const imgData = canvas.toDataURL("image/png");

    element.style.display = "none";

    const newWindow = window.open();
    newWindow.document.write('<img src="' + imgData + '" onload="window.print();window.close()" />');
  };

  return (
    <div className="admin-list-voters">
      <Content>
        <div className="admin-content-voters">
          <Row justify={"space-between"} align={"middle"}>
            <Title level={4}>Voters List</Title>
          </Row>
          <Alert
            message="List of Voters"
            description="List of your registered voters. If you think there's a problem with the list of users, please contact an administrator for assistance."
            type="info"
            showIcon
          />
          <Title level={5}><FilterOutlined /> Filter Voters</Title>
          <Row gutter={[10, 10]} className="filters">
            <Col span={8}>
              <Input
                placeholder="Enter name"
                allowClear
                size="large"
                onChange={(e) => setSearchName(e.target.value)}
              />
            </Col>
            {hasGender && (
              <Col span={8}>
                <Select
                  options={[
                    { value: 'Male', label: 'Male' },
                    { value: 'Female', label: 'Female' }
                  ]}
                  placeholder="Select Gender"
                  size="large"
                  onChange={(value) => setSearchGender(value)}
                />
              </Col>
            )}
            {hasStreet && (
              <Col span={8}>
                <Input
                  placeholder="Enter Street"
                  allowClear
                  size="large"
                  onChange={(e) => setSearchStreet(e.target.value)}
                />
              </Col>
            )}
            {hasAddress && (
              <Col span={8}>
                <Input
                  placeholder="Enter Address"
                  allowClear
                  size="large"
                  onChange={(e) => setSearchAddress(e.target.value)}
                />
              </Col>
            )}
            {hasPWD && (
              <Col>
                <Checkbox
                  checked={searchPWD}
                  onChange={(e) => setSearchPWD(e.target.checked)}
                > Is it a Person with disabilities?</Checkbox>
              </Col>
            )}
          </Row>
          <Button type="primary" icon={<FilterOutlined />} onClick={handleSearchVoter}>Search Voter</Button>
          <Collapse className="add-more-filters-collapse">
            <Panel header={<>Add more filters?</>} style={{width: "100%"}}>
              <Row gutter={15}>
                <Col>
                  <Checkbox 
                    checked={hasGender}
                    onChange={() => setHasGender(!hasGender)}
                  >Gender</Checkbox>
                </Col>
                <Col>
                  <Checkbox 
                    checked={hasStreet}
                    onChange={() => setHasStreet(!hasStreet)}
                  >Street</Checkbox>
                </Col>
                <Col>
                  <Checkbox 
                    checked={hasAddress}
                    onChange={() => setHasAddress(!hasAddress)}
                  >Address</Checkbox>
                </Col>
                <Col>
                  <Checkbox 
                    checked={hasPWD}
                    onChange={() => setHasPWD(!hasPWD)}
                  >PWD</Checkbox>
                </Col>
              </Row>
            </Panel>
          </Collapse>
          <Divider/>
          {
            showData ? (
            <>
              <div className="mobile-data">
                {(cloneDeep(voterStore.voters) ?? []).map((voter) => (
                  <Card
                    className="card-data"
                    actions={[
                      <Link to={'/voters/'+voter.VIN}><Button  icon={<EyeOutlined/>} type="primary" ghost style={{width: "95%"}}>View</Button></Link>,
                      <Button type="primary" ghost onClick={() => setVoterData(voter)} icon={<PrinterOutlined/>} style={{width: "95%"}}>Print Precinct</Button>,
                    ]}
                  >
                    <Text className="name-text" strong>{voter.FullName}</Text>
                    <Row gutter={10} align={"middle"}>
                      <Col>
                        <Text type="secondary">Precinct: </Text>
                      </Col>
                      <Col>
                        <Tag color={"blue"}>{voter.Precint}</Tag>
                      </Col>
                    </Row>
                    <Text type="secondary">{voter.Street}</Text>
                    <Text type="secondary">{voter.Address}</Text>
                  </Card>
                  ))
                }
              </div>
              <div className="web-data">
                <Table pagination={false} columns={columns} dataSource={cloneDeep(voterStore.voters)} bordered/>
              </div>
              <ul className="pagination">
                <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={voterStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
                <li className="pagination-item"><a>{voterStore.page}</a></li>
                <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={voterStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
              </ul>
            </>) : <Skeleton active/>
          }
        </div>
      </Content>
      <div ref={printRef} className="print-area" style={{ display: "none", fontSize: '13px'}}>
        <p>Name: {voterData?.FullName}</p>
        <p>Precinct: {voterData?.Precint}</p>
        <p>Street: {voterData?.Street}</p>
        <p>Address: {voterData?.Address}</p>
      </div>
    </div>

  );
};

export default inject('userStore', 'voterStore')(observer(Voters));
